export default "__VITE_ASSET__B3O9ctlQ__"